module.exports = __webpack_public_path__ + "img/home-slider-audi.7861a795.png";